import { filterConsistencyParamDeclarations } from "app/routes/handlers/filter-consistency/filterConsistencyUtils";
import { BasicDurations } from "app/services/DurationService";

import type { AIResearchParamsDefinition } from "./AIResearchRoutes.type";

const sharedParams = {
    duration: {
        type: "string",
        value: BasicDurations.LAST_THREE_MONTHS,
    },
    country: {
        type: "string",
    },
    filter: {
        type: "string",
        dynamic: true,
    },
    ...filterConsistencyParamDeclarations,
} as const;

export const industryParams: AIResearchParamsDefinition = {
    ...sharedParams,
    industry: {
        type: "string",
        dynamic: true,
    },
    subIndustry: {
        type: "string",
        dynamic: true,
    },
};

export const brandParams: AIResearchParamsDefinition = {
    ...sharedParams,
    myBrands: {
        type: "string",
        array: true,
        dynamic: true,
        value: [],
    },
    competitorBrands: {
        type: "string",
        array: true,
        dynamic: true,
        value: [],
    },
};

export const ROUTES = {
    home: "airesearch.home",
    brandResearch: "airesearch.brandResearch",
    brandResearchReport: "airesearch.brandResearch.report",
    industryResearch: "airesearch.industryResearch",
    industryResearchReport: "airesearch.industryResearch.report",
} as const;
